import { useSelectUserContext } from '@innovyze/stylovyze/lib/selectors';
import { InnovyzeRole } from '@innovyze/stylovyze/lib/utils/InnovyzeRole';
import { useMemo } from 'react';
export const useIsOwnerUser = (createdBy) => {
    const userContext = useSelectUserContext();
    const { innovyzeRole, id } = userContext;
    return useMemo(() => {
        return innovyzeRole === InnovyzeRole.ADMIN || createdBy === id;
    }, [createdBy, innovyzeRole, id]);
};
